import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { HttpUtilService } from '@services/http-util.service';
@Component({
  selector: 'app-youtube-search',
  templateUrl: './youtube-search.component.html',
  styleUrls: ['./youtube-search.component.scss']
})
export class YoutubeSearchComponent implements OnInit {
  selected;
  url;
  pages = [];
  currentPage = 0;
  @Output() selectItem = new EventEmitter<string>();
  @Input() data;
  constructor(private http: HttpUtilService) { }
  results
  value
  ngOnInit() {
  }
  setSelected(item) {
    console.log(item);
    this.selected = item;
    this.selectItem.emit(item.id.videoId);
  }

  search(query, next) {
    console.log(query,next)
    if (query) {
      if (query.match(/youtube\.com\/embed/)){
        var arr = query.split(/\//g)
        query = arr[arr.length - 1];
      } else if (query.match(/youtube\.com/)) {
        query = query.match(/v=[^&]+/i)[0];
        query = query.replace(/v=/, "");
      }

      this.url = "https://content.googleapis.com/youtube/v3/search?q=" + query + "&maxResults=24&type=video&part=snippet&key=AIzaSyB_KFB4z0OsuN5ylvx5ntRvWp__1XgMfRs";
      this.currentPage = 0;
      this.pages = [];
    }
    var url = this.url;
    if (next != null) {
      console.log("next is ",next)
      this.currentPage += next;
      if (this.pages[this.currentPage]) {
        this.results = this.pages[this.currentPage];
        return;
      } else {

        url += "&pageToken=" + (next == 1 ? this.results.nextPageToken : this.results.prevPageToken);

      }
    }
    console.log(url);
    this.http.request("GET", url).subscribe(result => {
      this.results = result;
      this.pages[this.currentPage] = result;
    });
  }







}
